import styled from "styled-components";

export const ScanContainerBtn = styled.button`
  opacity: ${(props) => (props.disabled ? "0.5" : 1)};
  border: 1px solid #0071bc;
  border-radius: 4px;
  color: #0071bc;
  padding: 8px 20px;
  font-weight: 500;
  max-width: 200px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  background-color: white;
  :hover,
  :active,
  :focus {
    background: #0071bc;
    color: #fff;
  }
`;

export const PrintScanBtn = styled.button`
  display: grid !important;
  grid-template-columns: auto 1fr;
  margin-top: 25vh;
`;
